<template>
  <div class="d-contents">
    <FormInput
      id="contractor-name"
      :value="form.name"
      :label-text="$t('Contractor name')"
      required
      :error="!!errors.name"
      :error-message="errors.name ? errors.name[0] : ''"
      @input="updateFormValue({ key: 'name', value: $event })"
    />
    <div class="contractors-modal__two-columns">
      <FormInput
        id="contractor-address"
        :value="form.address"
        :label-text="$t('Address')"
        @input="updateFormValue({ key: 'address', value: $event })"
      />
      <FormInput
        id="contractor-reg-number"
        :value="form.registration_number"
        :label-text="$t('Reg. number')"
        @input="updateFormValue({ key: 'registration_number', value: $event })"
      />
    </div>
    <Select
      v-if="showLanguageField || form.language"
      :value="form.language"
      :label-text="$t('Language')"
      :items="languagesList"
      @input="updateFormValue({ key: 'language', value: $event })"
    />
    <FormInput
      v-if="showWebsiteField || form.company_domain"
      id="contractor-website"
      :value="form.company_domain"
      :label-text="$t('Website')"
      @input="updateFormValue({ key: 'company_domain', value: $event })"
    />
    <div v-if="!showWebsiteField || !showLanguageField" class="spacex-8">
      <Button
        v-if="!showWebsiteField && !form.company_domain"
        size="small"
        type="secondary"
        icon="plus"
        @click.native="showWebsiteField = true"
      >
        {{ $t('Website') }}
      </Button>
      <Button
        v-if="!showLanguageField && !form.language"
        size="small"
        type="secondary"
        icon="plus"
        @click.native="showLanguageField = true"
      >
        {{ $t('Language') }}
      </Button>
    </div>
    <ContractorsModalGeneralTable v-if="form.contacts && form.contacts.length">
      <ContractorsModalGeneralTableHeader />
      <ContractorsModalGeneralTableRow
        v-for="(contact, index) in form.contacts"
        :key="index"
        :contact="contact"
        :row-errors="getContactRowErrors(index)"
        @input="updateContactInfo({ ...$event, index: index })"
        @remove-contact-row="removeContactRow(index)"
      />
    </ContractorsModalGeneralTable>
    <Button class="mt-16" type="secondary" icon="plus" size="small" @click.native="addContactRow">
      {{ $t('Add contact') }}
    </Button>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';
  import FormInput from '@/components/ui/FormInput';
  import ContractorsModalGeneralTable from '@/containers/contractors/add-contractors-modal/contractors-modal-general-table/ContractorsModalGeneralTable';
  import ContractorsModalGeneralTableRow from '@/containers/contractors/add-contractors-modal/contractors-modal-general-table/ContractorsModalGeneralTableRow';
  import ContractorsModalGeneralTableHeader from '@/containers/contractors/add-contractors-modal/contractors-modal-general-table/ContractorsModalGeneralTableHeader';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import Select from '@/components/ui/Select';

  export default {
    name: 'ContractorsGeneralTab',
    components: {
      ContractorsModalGeneralTableHeader,
      ContractorsModalGeneralTableRow,
      ContractorsModalGeneralTable,
      FormInput,
      Button,
      Select,
    },
    data() {
      return {
        showWebsiteField: false,
        showLanguageField: false,
      };
    },
    computed: {
      ...mapState('contractors', ['form', 'errors']),
      ...mapGetters('global', ['languagesList']),
    },
    methods: {
      ...mapActions('contractors', [
        'updateFormValue',
        'addContactRow',
        'updateContactInfo',
        'removeContactRow',
      ]),
      ...mapActions('modal', ['openModal']),
      getContactRowErrors(index) {
        return this.errors?.contacts?.[index] || {};
      },
    },
  };
</script>
